/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Pro_Feature_4Inputs */

const en_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary negotiation coach`)
};

const de_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsverhandlungs-Coach`)
};

const fr_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach de négociation salariale`)
};

const es_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach de negociación salarial`)
};

const it_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach per la negoziazione salariale`)
};

const nl_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salariisonderhandelingscoach`)
};

const pl_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening negocjacji wynagrodzenia`)
};

const fi_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkaneuvottelukouluttaja`)
};

const da_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lønforhandlingscoach`)
};

const sv_settings_pro_feature_4 = /** @type {(inputs: Settings_Pro_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löneförhandlingscoach`)
};

/**
* | output |
* | --- |
* | "Salary negotiation coach" |
*
* @param {Settings_Pro_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_pro_feature_4 = /** @type {((inputs?: Settings_Pro_Feature_4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Pro_Feature_4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_pro_feature_4(inputs)
	if (locale === "fr") return fr_settings_pro_feature_4(inputs)
	if (locale === "es") return es_settings_pro_feature_4(inputs)
	if (locale === "it") return it_settings_pro_feature_4(inputs)
	if (locale === "nl") return nl_settings_pro_feature_4(inputs)
	if (locale === "pl") return pl_settings_pro_feature_4(inputs)
	if (locale === "fi") return fi_settings_pro_feature_4(inputs)
	if (locale === "da") return da_settings_pro_feature_4(inputs)
	if (locale === "sv") return sv_settings_pro_feature_4(inputs)
	return en_settings_pro_feature_4(inputs)
});